import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import UnpaidBookings from './UnpaidBookings';
import { restrictUrls } from '../../../helpers/adminPrivileges';

function action({ store }) {
    const title = 'Unpaid jobs';

    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account && store.getState().account.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/login' }
    }

    // Memakai privilege jobs yang sama seperti Direct bookings: isinya sama-sama
    // daftar booking, hanya disaring berbeda.
    if (!restrictUrls('/siteadmin/jobs', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: (
            <AdminLayout>
                <UnpaidBookings />
            </AdminLayout>
        ),
    }
}

export default action;
